import { render, staticRenderFns } from "./PlayQuiz.vue?vue&type=template&id=390d5363&scoped=true&"
import script from "./PlayQuiz.vue?vue&type=script&lang=js&"
export * from "./PlayQuiz.vue?vue&type=script&lang=js&"
import style0 from "./PlayQuiz.vue?vue&type=style&index=0&id=390d5363&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390d5363",
  null
  
)

export default component.exports